export default __webpack_public_path__ + "static/media/Gshar_Logo_NEW.89106943.png";